import React from "react";

const NotFound = props => (
  <div>
    Not Fund!!!!!!!!!!!
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js